import * as React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { LineChart } from '@mui/x-charts/LineChart';
import { ChartsReferenceLine } from '@mui/x-charts/ChartsReferenceLine';

function AreaGradient({ color, id }) {
  return (
    <defs>
      <linearGradient id={id} x1="50%" y1="0%" x2="50%" y2="100%">
        <stop offset="0%" stopColor={color} stopOpacity={0.5} />
        <stop offset="100%" stopColor={color} stopOpacity={0} />
      </linearGradient>
    </defs>
  );
}

AreaGradient.propTypes = {
  color: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};



export default function SessionsChartSmall({ xAxisScaleType, xLabel = 'x', yLabel = 'y',
  data, tickInterval = 12, referencelineLabel, referenceLineY, referenceLineX }) {
  const theme = useTheme();
  if (!Array.isArray(data)) {
    return null;
  }
  const dataLabels = data.map(d => d.label) || [];
  const colorPalette = [
    theme.palette.primary.light,
  ];

  return (
    <Card variant="outlined" sx={{ width: '400px' }}>
      <CardContent>
        <LineChart
          colors={colorPalette}
          xAxis={[
            {
              scaleType: xAxisScaleType || 'point',
              data: dataLabels,
              tickInterval: (index, i) => (i + 1) % tickInterval === 0,
              tickLabelStyle: {
                fontSize: 8,
              },
            },
          ]}
          yAxis={[{
            min: 0,
            label: yLabel,
            labelFontSize: 9,
            tickLabelStyle: {
              fontSize: 8,
            },
          }]}
          series={[
            {
              id: xLabel,
              label: xLabel,
              showMark: false,
              curve: 'linear',
              stack: 'total',
              area: true,
              stackOrder: 'ascending',
              data: data.map(d => d.value),
            }
          ]}
          height={210}
          margin={{ left: 50, right: 20, top: 20, bottom: 20 }}
          grid={{ horizontal: true }}
          sx={{
            '& .MuiAreaElement-series-charges': {
              fill: `url('#${xLabel}')`,
            },
          }}
          slotProps={{
            legend: {
              hidden: true,
            },
          }}
        >
          {referencelineLabel && referenceLineX &&
            <ChartsReferenceLine
              x={referenceLineX}
              labelStyle={{ fontSize: '10' }}
              label={referencelineLabel}
              labelAlign="start"
              stroke="red"
            />
          }
          {referencelineLabel && referenceLineY &&
            <ChartsReferenceLine
              y={referenceLineY}
              labelStyle={{ fontSize: '10' }}
              label={referencelineLabel}
              labelAlign="start"
              stroke="red"
            />
          }

          <AreaGradient color={theme.palette.primary.main} id={xLabel} />
        </LineChart>
      </CardContent>
    </Card>
  );
}
